import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "width-full" }
const _hoisted_2 = { class: "d-flex align-center width-full" }
const _hoisted_3 = { class: "text-medium-emphasis" }

import { useFilterStore } from "@/store/filter";
import FilterField from "./FilterField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterList',
  setup(__props) {

const filters = useFilterStore();

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Filters "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.$format.capitaliseEach(_unref(filters).state.name)), 1),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        variant: "text",
        size: "x-small",
        onClick: _unref(filters).clearAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Clear ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_v_divider, { class: "my-2" }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters).definitions, (definition, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createVNode(FilterField, {
          "model-value": _unref(filters).values[definition.value],
          definition: definition,
          onChange: ($event: any) => (_unref(filters).values[definition.value] = $event)
        }, null, 8, ["model-value", "definition", "onChange"]),
        (i < _unref(filters).definitions.length - 1)
          ? (_openBlock(), _createBlock(_component_v_divider, {
              key: 0,
              class: "my-2"
            }))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(_component_v_divider, { class: "mt-2" })
  ]))
}
}

})